import React from "react";
import { motion, AnimatePresence } from "framer-motion";

const AnimationOpen = ({ children }) => {
  const animatiate = {
    intial: {
      //   y: -100,
      opacity: 0,
    },
    animate: {
      //   y: 0,
      opacity: 1,
    },
    exit: {
      //   y: 100,
      opacity: 0,
    },
  };

  return (
    <AnimatePresence>
      <motion.div
        variants={animatiate}
        initial="intial"
        animate="animate"
        exit="exit"
        transition={{ duration: 0.5, ease: "easeInOut" }}
      >
        {children}
      </motion.div>
    </AnimatePresence>
  );
};

export default AnimationOpen;
